import { TValidationState } from '../../utils';
import { color } from '../variables';

const stateColors = {
  error: color.red02,
};

type TStateColors = string | undefined; // form state: "none" => undefined

export const getStateColors = (state: TValidationState): TStateColors => {
  return stateColors[state];
};
